import { ArrowLeftIcon } from '@rsos/assets/icons';
import CallSource from '@rsos/components/capstone/Location/CallSource';
import { Box, Text } from '@rsos/components/capstone/base';
import useHasLocationsToRender from '@rsos/hooks/useHasLocationsToRender';
import AgencyShareChatButton from '../../AgencyShareChat/AgencyShareChatButton';
import CopyAllButton from '../../CopyAllButton';
import {
  StyledHeader,
  StyledCallerID,
  Tools,
  StyledBackNavigation,
} from './CallPane.styles';

const BPLaptopHeader = ({ onClose, formattedPhone, source }) => {
  const hasLocationsToRender = useHasLocationsToRender();
  return (
    <StyledHeader data-name="event-pane-header">
      <Box align="center" horizontal justify="space-between">
        <Box horizontal flow={20}>
          <StyledBackNavigation onClick={() => onClose()}>
            <ArrowLeftIcon height={16} width={16} />
            <Text ml="3px" size="normal">
              Go Back
            </Text>
          </StyledBackNavigation>
          <Box horizontal flow={5} align="center">
            <StyledCallerID data-name="event-pane-caller-id">
              {formattedPhone}
            </StyledCallerID>
            {source && <CallSource source={source} />}
          </Box>
        </Box>

        {hasLocationsToRender && (
          <Tools align="center" horizontal data-name="event-pane-tools">
            <AgencyShareChatButton />
            <CopyAllButton />
          </Tools>
        )}
      </Box>
    </StyledHeader>
  );
};

export default BPLaptopHeader;
